import { clientApiFetch } from "@/lib/api/client/fetch"
import { type Company, type CreateCompanyPayload } from "@/lib/api/types"

export type { Company, CreateCompanyPayload }

interface CreateCompanyResponse {
  company: Company
}

export async function createCompany(
  payload: CreateCompanyPayload,
): Promise<Company> {
  const data = await clientApiFetch<CreateCompanyResponse>("/api/companies", {
    method: "POST",
    body: payload,
  })
  return data.company
}

export async function updateCompany(
  companyId: string,
  payload: { name: string },
): Promise<Company> {
  const data = await clientApiFetch<{ company: Company }>(
    `/api/companies/${companyId}`,
    {
      method: "PATCH",
      body: { name: payload.name },
    },
  )
  return data.company
}

export async function switchCompany(companyId: string): Promise<void> {
  await clientApiFetch<{ ok: boolean }>("/api/companies/switch", {
    method: "POST",
    body: { companyId },
  })
}
